<aayn-modal-for-payments
  icon="chevron-double-down"
  title="Downgrade Successful"
  description="You have just downgraded your ADYOUNEED plan. Click on the button below to continue."
  color="var(--orange)"
  [dismissFn]="dismissModals"
>
  <button ayn-button="orange" icon="circle-chevron-right" (click)="dismissModals()">Go To App</button>
</aayn-modal-for-payments>
